import { dateTimeHelper } from "@/assets/scripts/js/DateTimeHelper";

export class MockDb {
  constructor() {
    this.reset();
  }

  /* グループ設定 */
  static REQUESTER_LIST = [
    { value: "1", name: "BYD" },
    { value: "2", name: "ジャガー" },
    { value: "3", name: "ボルボ" },
    { value: "4", name: "ベンツ" },
  ];
  static DEPARTURE_AREA_LIST = [
    { value: "1", name: "発地エリア1" },
    { value: "2", name: "発地エリア2" },
  ];
  static ARRIVAL_AREA_LIST = [
    { value: "1", name: "着地エリア1" },
    { value: "2", name: "着地エリア2" },
    { value: "3", name: "着地エリア3" },
    { value: "4", name: "着地エリア4" },
  ];
  static CAR_TYPE_LIST = MockDb.REQUESTER_LIST.map((item) => ({
    value: item.value,
    name: item.name + " " + (Math.floor(Math.random() * 10) + 100),
  }));

  /* グループ一覧 */
  static STATUS_LIST = [
    { value: "1", name: "グループ設定済み" },
    { value: "2", name: "納期回答算出済み" },
    { value: "3", name: "確定済み" },
    { value: "4", name: "ダウンロード済み" },
  ];

  reset() {
    const currentDate = new Date();
    const nextDate = new Date(currentDate);
    nextDate.setDate(currentDate.getDate() + 1);

    this.ungroupRequests = new Array(2000).fill({}).map((item, index) => {
      var requesterIndex = Math.floor(Math.random() * MockDb.REQUESTER_LIST.length);
      var departureAreaIndex = Math.floor(Math.random() * MockDb.DEPARTURE_AREA_LIST.length);
      var arrivalAreaIndex = Math.floor(Math.random() * MockDb.ARRIVAL_AREA_LIST.length);

      return {
        requestId: index,
        requestNo: 2500013755 + index,
        detailNo: 1 + index + Math.floor(Math.random() * MockDb.REQUESTER_LIST.length),
        requesterId: MockDb.REQUESTER_LIST[requesterIndex].value,
        requester: MockDb.REQUESTER_LIST[requesterIndex].name,
        requestDate: dateTimeHelper.toStringDate("yyyy/MM/dd", currentDate),
        shipDate: dateTimeHelper.toStringDate("yyyy/MM/dd", nextDate),
        carTypeId: MockDb.CAR_TYPE_LIST[requesterIndex].value,
        carType: MockDb.CAR_TYPE_LIST[requesterIndex].name,
        frameNumber: "LGXCH4CD2S2201288",
        departureLocationId: MockDb.DEPARTURE_AREA_LIST[departureAreaIndex].value,
        departureLocation: MockDb.DEPARTURE_AREA_LIST[departureAreaIndex].name.replace(
          "エリア",
          ""
        ),
        arrivalLocationId: MockDb.ARRIVAL_AREA_LIST[arrivalAreaIndex].value,
        arrivalLocation: MockDb.ARRIVAL_AREA_LIST[arrivalAreaIndex].name.replace("エリア", ""),
        departureAreaId: MockDb.DEPARTURE_AREA_LIST[departureAreaIndex].value,
        departureArea: MockDb.DEPARTURE_AREA_LIST[departureAreaIndex].name,
        arrivalAreaId: MockDb.ARRIVAL_AREA_LIST[arrivalAreaIndex].value,
        arrivalArea: MockDb.ARRIVAL_AREA_LIST[arrivalAreaIndex].name,
        importDate: dateTimeHelper.toStringDate("yyyy/MM/dd", currentDate),
        importUser: "〇〇〇〇",
        groupId: null,
      };
    });

    this.groups = new Array(7).fill({}).map((item, index) => {
      const requesterIndex = Math.floor(Math.random() * MockDb.REQUESTER_LIST.length);
      const statusIndex = Math.floor(Math.random() * MockDb.STATUS_LIST.length);
      const statusId = MockDb.STATUS_LIST[statusIndex].value;
      const baseDate = dateTimeHelper.toStringDate("yyyy/MM/dd", nextDate);
      const finalCalculationDateTime = dateTimeHelper.toStringDate("yyyy/MM/dd HH:mm", currentDate);
      const confirmDate = dateTimeHelper.toStringDate("yyyy/MM/dd", currentDate);
      const lastDownloadDate = dateTimeHelper.toStringDate("yyyy/MM/dd", currentDate);

      return {
        groupId: index + 1,
        groupNo: `N0000${index + 1}`,
        groupName: MockDb.REQUESTER_LIST[requesterIndex].name,
        statusId: MockDb.STATUS_LIST[statusIndex].value,
        status: MockDb.STATUS_LIST[statusIndex].name,
        baseDate: statusId > "1" ? baseDate : "",
        finalCalculationDateTime: statusId > "1" ? finalCalculationDateTime : "",
        confirmDate: statusId > "2" ? confirmDate : "",
        lastDownloadDate: statusId > "3" ? lastDownloadDate : "",
        lastGroupSettingUser: "〇〇〇〇",
        lastCalculationUser: statusId > "1" ? "〇〇〇〇" : "",
        lastDownloadUser: statusId > "3" ? "〇〇〇〇" : "",
      };
    });
  }

  // ID採番
  nextId(collection) {
    const list = this[collection];
    return list.length + 1;
  }
}

export const mockDb = new MockDb();
